import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-xhm-partner",
  "use": "icon-soc-l1-xhm-partner-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-xhm-partner\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n  <circle cx=\"352\" cy=\"320\" r=\"112\" />\r\n  <circle cx=\"672\" cy=\"320\" r=\"112\" />\r\n  <path d=\"M160 800c32-160 112-240 192-240s160 80 192 240H160z\" />\r\n  <path d=\"M480 800c32-160 112-240 192-240s160 80 192 240H480z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-xhm-partner.svg
// module id = /qxh
// module chunks = 534